export default __webpack_public_path__ + "static/168-c0fe12f48913f0acc912fc6f468c87be.gif";